import queryString from 'qs'
import useSWR from 'swr'

import {dayjs} from '~/dates/dayjs'

import {getDeimos} from './helpers'

export type EstimateBillingPriceRequest = {
    startDate: string
    planType: string
    contract: boolean
    numberOfUsers: number
    intervalCommitment: number
    numberOfBookkeepers?: number
    numberofCardOrders?: number
    freeAdministrators?: number
    contractPrice?: string | null
    couponId?: string
    intervalType?: 'YEARLY' | 'MONTHLY' | 'ONE_TIME'
    includeCashback?: boolean
}

export type EstimateBillingPriceParams = Omit<EstimateBillingPriceRequest, 'startDate'> & {
    startDate: Date
}

export type EstimateBillingPriceResponse = {
    startDate: string
    contract: boolean
    contractPrice: number | null
    couponId: string | null
    planType: string | null
    numberOfUsers: number | null
    freeAdministrators: number | null
    totalPrice: {value: number; currency: string}
    subtotal: {value: number; currency: string}
    subtotalPrice: number
    unitPrice: number
    vatPercentage: number
    discountPercentage: number
    currency: string
    invoiceDate: string | null
}

const toLocalDate = (date: Date) => {
    return dayjs(date).format('YYYY-MM-DD')
}

export function useCompanyEstimatedBillingPrice(
    companyId: string | null,
    params: EstimateBillingPriceParams,
) {
    const nextParams: EstimateBillingPriceRequest = {
        ...params,
        startDate: toLocalDate(params.startDate),
    }

    const query = nextParams
        ? queryString.stringify(nextParams, {addQueryPrefix: true, skipNulls: true})
        : ''
    return useSWR<EstimateBillingPriceResponse, Error>(
        companyId ? `/rest/v1/billing/companies/${companyId}/estimate-billing-price${query}` : null,
        getDeimos,
        {refreshInterval: 0},
    )
}
